import styled from 'styled-components';

export const HeaderContainer = styled.div`
  padding: 10px 16px;
  gap: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e2e4e6;
`;

export const DrawerTitle = styled.h1`
  color: rgba(0, 0, 0, 0.87);
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.15px;
  margin: 0;
  padding: 0;
`;

export const ContentContainer = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1;
  overflow-y: auto;
`;

export const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
`;

export const FieldLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.87);
`;

export const FieldValue = styled.span`
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
`;

export const DueByValue = styled(FieldValue)<{ $overdue: boolean }>`
  ${({ $overdue, theme }) => $overdue && `color: ${theme.palette.error.main};`}
`;

export const AssigneeList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const AssigneeRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const EditableAssigneeRow = styled(AssigneeRow)`
  cursor: pointer;
  padding: 4px 8px;
  margin: -4px -8px;
  border-radius: 4px;

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }

  svg {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.54);
    margin-left: auto;
  }
`;

export const AssigneeEditActions = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 4px;
`;

export const FooterContainer = styled.div`
  padding: 16px 24px;
  display: flex;
  gap: 12px;
`;

export const DrawerWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
`;

export const ReasonContainer = styled.div`
  display: flex;
  padding: 6px 16px;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 4px;
  background: #e6f3fa;
  width: 100%;
  gap: 12px;

  h1 {
    margin: 0;
    padding: 0;
    color: #032e5c;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 4px;
  }

  p {
    margin: 0;
    padding: 0;
    color: rgba(0, 0, 0, 0.87);
    font-size: 16px;
    font-weight: 400;
  }
`;
